import { createSlice } from "@reduxjs/toolkit";

import {
  login,
  getMe,
  updateMe,
  updatePassword,
  updateAuthenticatorCode,

  //for isLoading
  createUser,
  updateUser,
  unblockUser,
  getUsers,
  blockUser,
  changeUserPassword,
  getTotalInfo,
  getLastMonthInfo,
  getAllClientLogs,
  getClientLogReport,
  getClientLogByTransactionId,
} from "../thunks/User";

import { getDepositQueue, getDepositHistory } from "../thunks/Deposit";
import { getWithdrawalQueue, getWithdrawalHistory } from "../thunks/Withdrawal";

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    isLoading: false,
    clientLogs: [],
    clientLogReport: null,
    currentClientLog: null,
    clientLogsLoading: false,
    clientLogReportLoading: false,
    clientLogByIdLoading: false,
    clientLogsError: null,
    clientLogReportError: null,
    clientLogByIdError: null,
  },
  //   reducers: {
  //     setUser: (state, action) => {
  //       state.user = action.payload;
  //     },
  //   },
  extraReducers(builder) {
    builder.addCase(getMe.fulfilled, (state, action) => {
      state.user = action.payload.data.data;
    });

    builder.addCase(updateMe.fulfilled, (state, action) => {
      state.user = action.payload.data.data;
    });

    builder.addCase(updatePassword.fulfilled, (state, action) => {
      state.user = action.payload.data.data;
    });

    builder.addCase(updateAuthenticatorCode.fulfilled, (state, action) => {
      state.user.user.googleAuthenticatorCode =
        action.payload.data.googleAuthenticatorCode;
    });

    //for isLoading
    builder.addCase(createUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createUser.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(updateUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateUser.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(getUsers.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUsers.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(blockUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(blockUser.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(changeUserPassword.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(changeUserPassword.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(getTotalInfo.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getTotalInfo.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(getLastMonthInfo.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getLastMonthInfo.fulfilled, (state) => {
      state.isLoading = false;
    });

    // Handle getAllClientLogs
    builder
      .addCase(getAllClientLogs.pending, (state) => {
        state.clientLogsLoading = true;
        state.clientLogsError = null;
      })
      .addCase(getAllClientLogs.fulfilled, (state, action) => {
        state.clientLogsLoading = false;
        state.clientLogs = action.payload.data.logs;
      })
      .addCase(getAllClientLogs.rejected, (state, action) => {
        state.clientLogsLoading = false;
        state.clientLogsError = action.payload;
      });

    // Handle getClientLogReport
    builder
      .addCase(getClientLogReport.pending, (state) => {
        state.clientLogReportLoading = true;
        state.clientLogReportError = null;
      })
      .addCase(getClientLogReport.fulfilled, (state, action) => {
        state.clientLogReportLoading = false;
        state.clientLogReport = action.payload.data.report;
        state.clientLogs = action.payload.data.logs;
      })
      .addCase(getClientLogReport.rejected, (state, action) => {
        state.clientLogReportLoading = false;
        state.clientLogReportError = action.payload;
      });

    // Handle getClientLogByTransactionId
    builder
      .addCase(getClientLogByTransactionId.pending, (state) => {
        state.clientLogByIdLoading = true;
        state.clientLogByIdError = null;
      })
      .addCase(getClientLogByTransactionId.fulfilled, (state, action) => {
        state.clientLogByIdLoading = false;
        state.currentClientLog = action.payload.data.logs[0];
      })
      .addCase(getClientLogByTransactionId.rejected, (state, action) => {
        state.clientLogByIdLoading = false;
        state.clientLogByIdError = action.payload;
      });
  },
});

export const userReducer = userSlice.reducer;
